import { Component } from 'react';
import { withGoogleReCaptcha } from 'react-google-recaptcha-v3';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { reduxForm } from 'redux-form';

import { FormError, Layout, Title } from 'common/components/layout';
import { removeSpaces } from 'common/helpers/miscHelper';
import { integerFormat } from 'common/helpers/numberHelper';
import SubMenu from 'profile/common/SubMenu';
import { listClubMemberships } from 'redux/clubMemberships/actions';
import { getActiveClubMemberships } from 'redux/clubMemberships/reducers';
import {
  deleteCustomerCreditCard,
  editCustomerCreditCard
} from 'redux/customerCreditCards/actions';

import AddEditForm from '../components/AddEditForm';
import ClubMembershipCreditCardVerify from '../components/ClubMembershipCreditCardVerify';
import { isClubMembershipsWithoutThisCreditCard } from '../helpers';
import { validateEdit } from '../validators';

class CreditCardEdit extends Component {
  constructor(props) {
    super(props);
    this.state = {
      modal: null,
      isSubmitting: false
    };
  }

  componentDidMount() {
    const { props } = this;
    props.listClubMemberships();
  }

  handleClubMembershipCreditCardVerify = () => {
    this.setState({
      modal: 'ClubMembershipCreditCardVerify'
    });
  };

  handleSubmit = async (form) => {
    this.setState({
      isSubmitting: true
    });

    const { props } = this;
    const { id } = props.match.params;
    const data = transformData(form);
    const { executeRecaptcha } = props.googleReCaptchaProps;
    const token = await executeRecaptcha('creditCardUpdate');
    data.recaptchaToken = token;

    const { activeClubMemberships } = this.props;
    let successFunction = () => {
      this.setState({
        isSubmitting: false
      });

      props.history.push('/profile/credit-card');
    };
    if (isClubMembershipsWithoutThisCreditCard(id, activeClubMemberships)) {
      successFunction = () => {
        this.handleClubMembershipCreditCardVerify();
      };
    }
    props.editCustomerCreditCard(id, data, successFunction);
  };

  handleDelete = (e) => {
    const { props } = this;
    e.preventDefault();
    const { id } = props.match.params;
    const successFunction = () => {
      props.history.push('/profile/credit-card');
    };
    props.deleteCustomerCreditCard(id, successFunction);
  };

  handleCancel = () => {
    const { props } = this;
    props.history.push('/profile/credit-card');
  };

  handleCloseModal = () => {
    const { props } = this;
    this.setState({
      modal: null
    });
    props.history.push('/profile/credit-card');
  };

  render() {
    const { settings, customerCreditCards, form, match } = this.props;
    const { id } = match.params;
    const { modal, isSubmitting } = this.state;

    if (!settings.data || !customerCreditCards.data) {
      return (
        <Layout title="Edit Credit Card" loading>
          <Title>Your Account</Title>
          <SubMenu />
        </Layout>
      );
    }
    const { handleSubmit, object } = this.props;

    const cardsArr = Object.keys(customerCreditCards.data);
    const isFirstCard = cardsArr.length === 1 || false;

    return (
      <Layout title="Edit Credit Card">
        <Title>Your Account</Title>
        <SubMenu />
        <div className="c7-account__credit-cards">
          <h2>Edit credit card</h2>
          <FormError formName={form} />
          <AddEditForm
            onSubmit={handleSubmit(this.handleSubmit)}
            saveButtonText={!isSubmitting ? 'Update Credit Card' : 'Loading...'}
            object={object}
            showCreditEdit={false}
            isFirstCard={isFirstCard}
            onCancelFunction={this.handleCancel}
          />
          <div className="c7-account-row c7-account-row--delete">
            <a onClick={this.handleDelete}>Delete this card</a>
          </div>
        </div>
        {renderModal(modal, this.handleCloseModal, id)}
      </Layout>
    );
  }
}

const renderModal = (modal, handleCloseModal, creditCardId) => {
  switch (modal) {
    case 'ClubMembershipCreditCardVerify': {
      return (
        <ClubMembershipCreditCardVerify
          onCloseModal={handleCloseModal}
          creditCardId={creditCardId}
        />
      );
    }
    default: {
      return null;
    }
  }
};

const transformData = (values) => {
  const data = {
    cardNumber: values.cardNumber && removeSpaces(values.cardNumber),
    expiryMo: values.expiryMo && integerFormat(values.expiryMo),
    expiryYr: values.expiryYr && integerFormat(values.expiryYr),
    cvv2: values.cvv2,
    cardHolderName: values.cardHolderName,
    isDefault: values.isDefault
  };
  return data;
};

const validate = (values) => {
  const data = transformData(values);
  const errors = validateEdit(data);
  return errors;
};

const mapStateToProps = (state, ownProps) => {
  let formValues = {};
  if (state.customerCreditCard.data) {
    formValues = {
      ...state.customerCreditCard.data[ownProps.match.params.id]
    };
    formValues.expiryMo = formValues.expiryMo && formValues.expiryMo.toString();
    formValues.expiryYr = formValues.expiryYr && formValues.expiryYr.toString();
  }
  return {
    initialValues: formValues,
    object:
      state.customerCreditCard.data &&
      state.customerCreditCard.data[ownProps.match.params.id],
    isFetching: state.customerCreditCard.isFetching,
    settings: state.setting,
    customerCreditCards: state.customerCreditCard,
    activeClubMemberships: getActiveClubMemberships(state.clubMembership)
  };
};

CreditCardEdit = reduxForm({
  form: 'Edit Credit Card',
  enableReinitialize: true,
  onSubmitFail: (err, dispatch) => {
    dispatch({ type: 'ADD_FORM_ERROR', payload: err });
  },
  onSubmitSuccess: (result, dispatch) => {
    dispatch({ type: 'REMOVE_FORM_ERROR' });
  },
  validate
})(CreditCardEdit);

export default withGoogleReCaptcha(
  withRouter(
    connect(mapStateToProps, {
      editCustomerCreditCard,
      deleteCustomerCreditCard,
      listClubMemberships
    })(CreditCardEdit)
  )
);
